import React from 'react'
import './kovin.css';



function DrChathurieNupearachchi() {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">National</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/chathurie.png" alt=" Dr. Chathurie Nupearachchi" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3> Dr. Chathurie Nupearachchi</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">
              Dr. Chathurie Niluka Nupearachchi plays many roles as a lecturer, researcher, speaker, writer, STEM advocate and education consultant with experience of over 15 years in the field of Higher Education.
              <br /><br />
              Dr. Nupearachchi, a Physics lover received her Bachelor of Science (BSc) in 2009 with a first class from The Open University of Sri Lanka (OUSL) by being the batch second. Also, she got the faculty prize for the best performance in Physics. She completed her MPhil also from OUSL in 2012.
              <br /><br />
              In 2019, she obtained her PhD from OUSL where her research title was ‘Fabrication of Bio-Batteries Using Pith of Plants as Electrolytic Media’. She is an academic with research, consultancy and teaching components in equilibrium. Currently she is engaged in further research work of her PhD on rechargeable bio-batteries where she obtained a patent for OUSL with her supervisor Prof. Susira Perera. 
              <br /><br />
              She recently worked in the Faculty of Technology, University of Sri Jayewardenapura as a Senior Lecturer in Physics. Now she is attached to Edith Cowan University Sri Lanka Campus, Gateway Graduate School, SLIIT, Eye Care Institute and College of Optometry and Vision Science as a visiting lecturer.
              <br /><br />
              She has even focused on her education consultantancy firm Digimeet Education as CEO and Founder. 
              <br /><br />
              Her mission is to impart her passion for Physics to anybody in such a way that it contributes to the entire community without any barriers.
            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
           <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default DrChathurieNupearachchi